<div class="card" style="padding: 36px 32px;gap: 20px">
    <i 
        style="position:absolute; top: 8px; right: 12px; cursor: pointer;"
        (click)="dialogRef.close()"
        aria-label="Close modal">
        <img src="assets/images/icons/titan/titan-close.svg" alt="Close" width="16" height="16">
    </i>
    
    <div class="d-flex flex-column" style="gap:48px; padding-right: 20px;padding-left: 20px;">
      <app-embedded-loader
        [title]="title"
        [textContent]="textContent"
        [image]="image"
        [countdown]="countdown"
        [countdownText]="countdownText"
       >
      </app-embedded-loader>
      
      <div class="d-flex justify-content-center">
        <app-titan-button [variant]="'secondary'" (onPress)="dialogRef.close()">
          <ng-container children>
            <div>{{ buttonText }}</div>
          </ng-container>
        </app-titan-button>
      </div>
    </div>
  </div>
  